/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  PauseReminderMutationResponse,
  PauseReminderPathParams,
  PauseReminder400,
  PauseReminder403,
  PauseReminder404,
  PauseReminder500,
} from '../types/PauseReminder'

function getPauseReminderUrl({ id }: { id: PauseReminderPathParams['id'] }) {
  const res = {
    method: 'POST',
    url: `/api/v1/reminders/reminders/${id}/pause/` as const,
  }
  return res
}

/**
 * @description Pause a recurring reminder.
 * This endpoint:
 * - Removes the celery beat scheduled task
 * - Updates reminder status to PAUSED
 * - Only works for recurring reminders
 * - Keeps reminder active so it can be unpaused later
 * Args:
 * request: The HTTP request
 * pk: The reminder ID
 * Returns:
 * Response with success message or error details
 * @summary Pause a recurring reminder
 * {@link /api/v1/reminders/reminders/:id/pause/}
 */
export async function pauseReminder(
  { id }: { id: PauseReminderPathParams['id'] },
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    PauseReminderMutationResponse,
    ResponseErrorConfig<
      PauseReminder400 | PauseReminder403 | PauseReminder404 | PauseReminder500
    >,
    unknown
  >({
    method: 'POST',
    url: getPauseReminderUrl({ id }).url.toString(),
    ...requestConfig,
  })
  return res.data
}
